import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import moment from 'moment';
import Breadcrumbs from '../../common/Breadcrumbs';
import TableAjax from '../../сomponents/TableAjax';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';
import { clearTasks } from '../../actions/dashboard';
import { fetchProjectById } from '../../api/projects';
import { deleteWOById } from '../../api/dashboard';
import { fetchTasksByCustomer } from '../../api/customer';
import Preloader from '../../common/Preloader';
import {durationToString} from "../../utils/date";

export class ProjectTask extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.backToList = this.backToList.bind(this);
    this.getWorkOrders = this.getWorkOrders.bind(this);
    this.loadData = this.loadData.bind(this);

    this.state = {
      loading: true,
      items: Array.from([]),
      itemsCount: 0,
      container: false,
      search: '',
      itemsPerPage: 10,
      currentPage: 0,
      sortBy: 'task_id',
      sortDirection: 'desc',
      dueDateField: 'due_date'
    };

    this.columns = [
      'task_name',
      'customer',
      'description',
      'project_name',
      'po_number',
      'time_spend',
      'status',
      'task_created',
      'due_date',
      'ship_date'
    ];

    this.columnNames = [
      'Work order',
      'Customer',
      'Description',
      'Project',
      '#PO Number',
      'Time Spend',
      'Status',
      'Date created',
      'Due date',
      'Ship Date'
    ];
  }

  backToList() {
    this.props.backToList();
  }

  onSearch(search) {
    this.setState({ search }, () => {
      this.reloadData(true);
    });
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    }, () => this.reloadData(true));
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    }, this.reloadData);
  }

  onChangeSorting(sortBy, sortDirection) {
    const sortFields = {
      due_date: this.state.dueDateField,
      ship_date: 'field_40',
      po_number: 'field_36',
    };

    this.setState({sortBy: sortFields[sortBy] || sortBy, sortDirection},
      () => this.reloadData(true));
  }

  loadData() {
    this.reloadData();

    const id = path(['match', 'params', 'id'], this.props);
    this.props.getCurrentProject(id);
  }

  reloadData(reloadCurrentPage = false) {
    const id = path(['match', 'params', 'id'], this.props);
    const { itemsPerPage, currentPage, sortBy, sortDirection, search } = this.state;
    const newState = {loading: true, items: [], itemsCount: 0};

    if (reloadCurrentPage) {
      newState.currentPage = 0;
    }

    this.setState({...newState});
    this.props.loadList(id, itemsPerPage, currentPage + 1, sortBy, sortDirection, search);
  }

  componentWillReceiveProps (newProps) {
    const tasks = path(['customer', 'tasks'], newProps);
    const itemsCount = path(['customer', 'pagination', 'total'], newProps);

    if (tasks) {
      const extraFieldToShow = path(['customer', 'extra_field_to_show'], newProps) || [];
      const dueDateFieldMeta = extraFieldToShow.find((item) => item.label === 'Due date');
      const dueDateField = dueDateFieldMeta ? `extra_${dueDateFieldMeta.id}` : null;

      const items = this.prepareTableData(tasks, dueDateField);
      this.setState({loading: false, items, itemsCount, dueDateField});
    }
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    const prevLocation = path(['router', 'location', 'key'], prevProps);
    const currentLocation = path(['router', 'location', 'key'], this.props);
    if (prevLocation !== currentLocation) {
      this.loadData();
    }
  }

  componentWillUnmount() {
    this.props.clearData();
  }

  handlerDelete(id) {
    const customerId = path(['match', 'params', 'id'], this.props);

    this.props.handleObjectToDelete({
      id: parseInt(id),
      redirect: `/pages/project-task/${customerId}`,
      handler: deleteWOById,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'deleteWOById',
    });
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  getStatus(status) {
    const statuses = {
      'new': 'New',
      'hold': 'Hold',
      'in_progress': 'In Progress',
      'hot': 'HOT',
      're_work': 'Re-work',
      'ready': 'Ready',
      'closed': 'Closed',
    };

    return statuses[status] || status;
  }

  prepareTableData(items, dueDateField) {
    return items.map((item) => ({
      key: item.task_id,
      id: item.task_id,
      user_id: item.user_id,
      task_name: item.task_name,
      customer: item.customer,
      project_name: item.project_name,
      po_number: item.field_36,
      time_spend: durationToString(item.time_spend),
      status: this.getStatus(item.status),
      task_created: item.task_created ? moment(item.task_created).format('M/D/YYYY') : '',
      due_date: dueDateField && item[dueDateField] ? moment(item[dueDateField]).format('M/D/YYYY') : '',
      ship_date: item.field_40 ? moment(item.field_40).format('M/D/YYYY') : '',
      description: item.description
    }));
  }

  getWorkOrders() {
    const { sortBy, sortDirection, itemsCount, itemsPerPage, items, currentPage, search, loading } = this.state;

    const itemActions = {
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        permission: { 'permAreaKey': 'workOrder', 'permTypeKey': 'edit' },
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },
      delete: {
        handler: this.handlerDelete,
        authorColumnName: 'user_id',
        permission: { 'permAreaKey': 'workOrder', 'permTypeKey': 'delete' },
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'delete',
      }
    };

    return (
      <TableAjax
        onApplySearch={this.onSearch}
        items={items}
        itemsCount={itemsCount}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={itemsPerPage}
        search={search}
        currentPage={currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        actions={itemActions}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
        defaultSort={{ column: sortBy, direction: sortDirection }}
        onChangeSorting={this.onChangeSorting}
        noDataText={loading ? 'loading ...' : undefined}
      />
    );
  }

  render() {
    const { loading } = this.state;
    const workOrders = this.getWorkOrders();
    const currentProjectName = path(['projects', 'currentProject', 'name'], this.props);

    let preloader = null;

    if (loading) {
      preloader = (
        <Preloader
          show={true}
          type={'circle'}
        />
      );
    }

    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/customers', icon: 'account_circle', name: 'Customers' },
          { icon: 'chrome_reader_mode', name: currentProjectName },
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            {currentProjectName}
          </div>
          <div className="card-block">
            <div className="clearfix mb-3">
              <button
                className={'btn btn-danger btn-outline float-right'}
                style={{marginLeft: '10px'}}
                onClick={this.backToList}
              >
                <i className="fa fa-remove"></i>
                <span style={{paddingLeft: '3px'}}>Cancel</span>
              </button>
            </div>
            {preloader}
            {workOrders}
            <ConfirmAction id={'deleteWOById'} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadList: (id, itemsPerPage, currentPage, sortBy, sortDirection, search) => {
      fetchTasksByCustomer(id, itemsPerPage, currentPage, sortBy, sortDirection, search)(dispatch);
    },
    getCurrentProject: (id) => {
      fetchProjectById({ id, })(dispatch);
    },
    moveToEdit: (id) => {
      dispatch(push('/pages/task/' + id));
    },
    backToList: () => {
      dispatch(push('/pages/customers'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
    clearData: () => {
      dispatch(clearTasks());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectTask);



// WEBPACK FOOTER //
// ./src/containers/ProjectTask/index.js